import { restServices } from "cuba/services";
import { useQuery } from "react-query";

const fetchPositionDetails = async (positionGroupId: string) => {
  return restServices.positionStructureService.getPositionDetails({
    positionGroupId,
  });
};

export const usePositionDetails = (positionGroupId?: string) => {
  return useQuery({
    queryKey: ["positionDetails", positionGroupId],
    queryFn: () => fetchPositionDetails(positionGroupId!),
    enabled: !!positionGroupId,
    refetchOnWindowFocus: false,
    retry: false,
    onError: (error) => {
      console.error("❌ Ошибка загрузки деталей позиции:", error);
    },
  });
};
